(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blade-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-compare')) {
    /* The pool is already filtered to this product's own type by the template.
       Here we only rank it: in-stock first, then the nearest prices, so the
       table reads as "the same kind of product, the same specs". */
    class BladeCompare extends HTMLElement {
      async connectedCallback() {
        this.table = this.querySelector('[data-table]');
        const current = JSON.parse(this.querySelector('[data-current]').textContent);
        const limit = Number(this.dataset.limit) || 3;

        let pool = [];
        try {
          pool = JSON.parse(this.querySelector('[data-pool]').textContent) || [];
        } catch (e) { pool = []; }

        /* Product type alone is too coarse here — "Accessories" holds both floor
           liners and glue — so a column also has to share words of the name.
           The score is the share of the two names that is common to both, which
           keeps the Duster MA-D500L beside the MA-D500S and leaves the wheel
           cleaner that merely mentions brake dust behind. */
        const mine = this.words(current.title, current.vendor);
        const myType = this.typeKey(current.type);
        const rank = (items) => {
          const seen = new Set([current.id]);
          const candidates = [];
          for (const p of items) {
            if (seen.has(p.id) || this.typeKey(p.type) !== myType) continue;
            seen.add(p.id);
            candidates.push({ p, words: this.words(p.title, p.vendor) });
          }

          /* Which shared words actually mean something is a question only the
             catalogue can answer. Among these candidates "helmet" sits on every
             one and "Gifts" on every novelty item — house style, not identity —
             while the model code "09b" sits on half, and that is what makes two
             helmets the same helmet. So a word carried by more than seven in ten
             candidates cannot be the reason to compare, and neither can a bare
             measurement: 473ml does not make a leather cleaner a hard wax. */
          const seenIn = new Map();
          for (const c of candidates) {
            c.words.forEach((w) => seenIn.set(w, (seenIn.get(w) || 0) + 1));
          }
          const measure = /^\d+(\.\d+)?(ml|l|g|kg|mm|cm|oz|w|v|a|ah|wh|yds?|meters?)$/;
          const tells = (w) => !measure.test(w)
            && (candidates.length < 5 || (seenIn.get(w) || 0) / candidates.length <= 0.7);

          const myWords = [...mine];
          const scored = [];
          for (const c of candidates) {
            const theirs = [...c.words];
            const shared = myWords.filter((w) => theirs.includes(w));
            if (!shared.some(tells)) continue;
            const union = new Set([...myWords, ...theirs]).size;
            scored.push({ p: c.p, score: shared.length / union, gap: Math.abs(c.p.price - current.price) });
          }
          if (!scored.length) return scored;
          /* Keep the company the closest match keeps: well adrift of the best
             match means a different kind of thing, not a rival. */
          const best = Math.max(...scored.map((x) => x.score));
          if (best < 0.1) return [];
          return scored
            .filter((x) => x.score >= best * 0.5)
            .sort((a, b) => (b.p.available - a.p.available) || (b.score - a.score) || (a.gap - b.gap));
        };

        /* Each source adds to the pool; none of them replaces it. */
        let found = pool;
        let ranked = rank(found);

        /* Liquid only sees 50 products per collection, so read them in full. */
        if (current.type && ranked.length < limit) {
          found = found.concat(await this.fromCollections(current, limit, myType));
          ranked = rank(found);
        }

        /* Still thin, or only a loose match: the closest products may sit in no
           collection this one belongs to — a newly added range usually does — so
           ask search for them by name and type. */
        if (current.type && (!ranked.length || ranked[0].score < 0.3)) {
          found = found.concat(await this.fromSearch(current, limit, myType));
          ranked = rank(found);
        }

        const others = ranked.slice(0, limit).map((x) => x.p);
        /* One lonely rival stretches the table into two huge columns, so the
           section needs at least two to be worth drawing at all. */
        if (others.length < 2) return;

        this.items = [current, ...others];
        this.render(current);
        this.hidden = false;
        this.querySelector('[data-diff]').addEventListener('change', (e) => {
          this.table.classList.toggle('is-diff', e.target.checked);
        });
      }

      /* The catalogue spells the same kind of thing several ways — "Oils &
         Fluids", "Oil and Fluids", "Oils and Fluids" — so types are matched on
         their words, singular and unordered, rather than character by character.
         "Oils & Chemicals" stays a different type, as it should. */
      typeKey(type) {
        return String(type || '').toLowerCase()
          .split(/[^a-z0-9]+/)
          .filter((w) => w && w !== 'and')
          .map((w) => w.replace(/s$/, ''))
          .sort()
          .join(' ');
      }

      /* The words that say what a product IS. Model codes, sizes and filler go,
         and so do the words that say nothing about the kind of thing: colours,
         marketing adjectives, and "car" and "blade", which sit in half the
         catalogue and in the shop's own name. Without that, a skate pad meets
         a bike saddle on the word "black", and a reversing camera meets a wiper
         on the word "Blade". */
      words(title, vendor) {
        const stop = new Set([
          'for', 'with', 'and', 'the', 'pcs', 'pack', 'set', 'per', 'new', 'use', 'size',
          'small', 'large', 'medium', 'piece', 'type', 'fit', 'fits', 'kit', 'free', 'made',
          'black', 'white', 'red', 'blue', 'grey', 'gray', 'silver', 'green', 'yellow',
          'brown', 'pink', 'orange', 'purple', 'violet', 'gold', 'beige', 'clear', 'assorted',
          'color', 'colors', 'colour', 'colours', 'multicolor',
          'car', 'auto', 'automotive', 'blade', 'universal', 'premium', 'heavy', 'duty',
          'high', 'low', 'super', 'mini', 'original', 'style', 'design', 'ready', 'stock',
          'quality', 'professional', 'pro', 'value', 'multi', 'series', 'model', 'inch', 'inches',
          'ultimate', 'superior', 'advanced', 'extra', 'best', 'top', 'great',
        ]);
        /* The brand name says who made it, not what it is: without this, a
           Microtex duster "matches" Microtex shampoo, wash pads and tyre black. */
        const brand = new Set(String(vendor || '').toLowerCase().split(/[^a-z0-9]+/)
          .filter(Boolean).map((w) => this.stem(w)));
        return new Set(String(title || '').toLowerCase().split(/[^a-z0-9]+/)
          .filter((w) => w.length > 2 && !/^\d+$/.test(w) && !stop.has(w))
          .filter((w) => !/^\d+(pcs?|pack|pk|pair|set|pieces?)$/.test(w))
          .map((w) => this.stem(w))
          /* checked again after stemming: "Designs" and "Colors" only become
             the filler words "design" and "color" once the plural is off */
          .filter((w) => !stop.has(w) && !brand.has(w)));
      }

      /* Enough stemming that "Beard Trimming Kit" reaches "Body Trimmer", and
         no more: suffix off, then a doubled final consonant collapsed. */
      stem(word) {
        let w = word;
        if (w.length > 5 && w.endsWith('ing')) w = w.slice(0, -3);
        else if (w.length > 5 && w.endsWith('ers')) w = w.slice(0, -3);
        else if (w.length > 4 && w.endsWith('er')) w = w.slice(0, -2);
        else if (w.length > 3 && w.endsWith('s')) w = w.slice(0, -1);
        if (w.length > 3 && w[w.length - 1] === w[w.length - 2]) w = w.slice(0, -1);
        return w;
      }

      overlap(mine, title, vendor) {
        const theirs = this.words(title, vendor);
        let n = 0;
        mine.forEach((w) => { if (theirs.has(w)) n += 1; });
        return n;
      }

      /* Search can filter on product_type, which reaches products that share
         the type but no collection with this one. It returns no SKU, so each
         hit is read back from its own product JSON for the full row data. */
      async fromSearch(current, limit, myType) {
        const root = window.Shopify?.routes?.root || '/';
        const ask = async (q) => {
          try {
            const res = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`);
            return (await res.json()).resources.results.products || [];
          } catch (e) { return []; }
        };

        /* Ask for this product's own words first — a new NightHawk headlight
           should meet the other NightHawk headlights, not any Auto Part. */
        const terms = [...this.words(current.title, current.vendor)].slice(0, 4).join(' ');
        let hits = terms ? await ask(`${terms} product_type:"${current.type}"`) : [];
        if (!hits.length) hits = await ask(`product_type:"${current.type}"`);

        const handles = hits
          .filter((p) => p.id !== current.id && this.typeKey(p.type) === myType)
          .map((p) => p.handle)
          .slice(0, limit + 1);

        const found = [];
        for (const handle of handles) {
          try {
            const res = await fetch(`${root}products/${handle}.js`);
            const p = await res.json();
            if (p.id === current.id || this.typeKey(p.type) !== myType) continue;
            const v = p.variants.find((x) => x.available) || p.variants[0] || {};
            found.push({
              id: p.id,
              title: p.title,
              url: `${root}products/${p.handle}`,
              image: p.featured_image || '',
              type: p.type,
              vendor: p.vendor,
              price: Number(v.price || p.price || 0),
              was: Number(v.compare_at_price || 0) > Number(v.price || 0) ? Number(v.compare_at_price) : 0,
              sku: v.sku || '',
              available: !!p.available,
            });
          } catch (e) { /* skip this one */ }
        }
        return found;
      }

      /* Reads the product's own collections in full and keeps only the items
         carrying the same product type. Prices here arrive as decimal strings,
         unlike the cents the rest of the theme works in. */
      async fromCollections(current, limit, myType) {
        let handles = [];
        try {
          handles = JSON.parse(this.querySelector('[data-collections]').textContent) || [];
        } catch (e) { return []; }

        const root = window.Shopify?.routes?.root || '/';
        const seen = new Set([current.id]);
        const found = [];
        for (const handle of handles) {
          if (found.length >= 60) break;
          let items = [];
          try {
            const res = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250`);
            items = ((await res.json()).products) || [];
          } catch (e) { continue; }
          for (const p of items) {
            if (this.typeKey(p.product_type) !== myType || seen.has(p.id)) continue;
            seen.add(p.id);
            const v = p.variants.find((x) => x.available) || p.variants[0] || {};
            const price = Math.round(parseFloat(v.price || '0') * 100);
            const was = Math.round(parseFloat(v.compare_at_price || '0') * 100);
            found.push({
              id: p.id,
              title: p.title,
              url: `${root}products/${p.handle}`,
              image: (p.images && p.images[0] && p.images[0].src) || '',
              type: p.product_type,
              vendor: p.vendor,
              price: price,
              was: was > price ? was : 0,
              sku: v.sku || '',
              available: !!v.available,
            });
          }
        }
        return found;
      }

      money(cents) {
        const amount = Number(cents) / 100;
        const whole = Math.round(amount) === amount;
        const text = amount.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
        return (this.dataset.moneyFormat || '₱{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, text);
      }

      render(current) {
        const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        const rows = [
          ['Product type', (p) => p.type || '—'],
          ['Brand', (p) => p.vendor || '—'],
          ['Price', (p) => this.money(p.price)],
          ['Was', (p) => (p.was ? this.money(p.was) : '—')],
          ['Discount', (p) => (p.was ? Math.round((1 - p.price / p.was) * 100) + '% off' : 'No discount')],
          ['Availability', (p) => (p.available ? 'In stock' : 'Sold out')],
        ];
        const here = (p) => (p.id === current.id ? ' cmp__col--here' : '');

        this.table.style.setProperty('--cmp-cols', this.items.length);
        const head = '<tr><th class="cmp__lbl"></th>' + this.items.map((p) => {
          const isHere = p.id === current.id;
          const img = p.image ? `<img src="${esc(p.image)}${p.image.includes('?') ? '&' : '?'}width=600" alt="" width="400" height="400" loading="lazy" decoding="async">` : '';
          return `<td class="cmp__head cmp__col${here(p)}"><div class="cmp__card">` +
            (isHere ? `<span class="cmp__tag">${esc(this.dataset.viewingLabel)}</span>` : '') +
            `<a class="cmp__ph" href="${esc(p.url)}">${img}</a>` +
            `<a class="cmp__n" href="${esc(p.url)}">${esc(p.title)}</a>` +
            `<span class="cmp__price"><span class="cmp__now">${this.money(p.price)}</span>` +
            (p.was ? `<span class="cmp__was">${this.money(p.was)}</span>` : '') + '</span>' +
            `<a class="cmp__btn" href="${esc(p.url)}">${esc(isHere ? this.dataset.hereLabel : this.dataset.viewLabel)}</a>` +
            '</div></td>';
        }).join('') + '</tr>';

        const body = rows.map(([label, read]) => {
          const values = this.items.map(read);
          const differs = new Set(values).size > 1 ? ' is-differs' : '';
          return `<tr><th class="cmp__lbl${differs}">${esc(label)}</th>` +
            this.items.map((p, i) => `<td class="cmp__col cmp__val${here(p)}${differs}">${esc(values[i])}</td>`).join('') +
            '</tr>';
        }).join('');

        this.table.innerHTML = `<thead>${head}</thead><tbody>${body}</tbody>`;
      }
    }
    customElements.define('blade-compare', BladeCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-faq')) {
    class BladeFaq extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const hd = e.target.closest('.pacc__hd');
          if (!hd) return;
          const open = hd.getAttribute('aria-expanded') === 'true';
          hd.setAttribute('aria-expanded', String(!open));
          document.getElementById(hd.getAttribute('aria-controls'))?.classList.toggle('is-open', !open);
        });
      }
    }
    customElements.define('blade-faq', BladeFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-footer')) {
    class BladeFooter extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const hd = e.target.closest('.acc__hd');
          if (!hd) return;
          const open = hd.getAttribute('aria-expanded') === 'true';
          hd.setAttribute('aria-expanded', String(!open));
          document.getElementById(hd.getAttribute('aria-controls'))?.classList.toggle('is-open', !open);
        });
      }
    }
    customElements.define('blade-footer', BladeFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-header')) {
    class BladeHeader extends HTMLElement {
      connectedCallback() {
        this.megaPanel = document.getElementById(this.dataset.mega);
        this.megaBtn = this.querySelector('[data-mega-trigger]');
        this.drawer = document.getElementById(this.dataset.drawer);
        this.scrim = this.querySelector('[data-scrim]');
        this.burger = this.querySelector('[data-open-drawer]');
        this.pointerOnNav = false;

        this.scroller = this.closest('.page-wrapper');
        this.onScroll = () => {
          const top = Math.max(window.scrollY, this.scroller ? this.scroller.scrollTop : 0);
          this.classList.toggle('is-stuck', top > 12);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        if (this.megaBtn && this.megaPanel) {
          this.megaBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const open = this.megaBtn.getAttribute('aria-expanded') === 'true';
            if (open && !this.pointerOnNav) this.closeMega(); else this.openMega();
          });
          this.megaBtn.addEventListener('mouseenter', () => { this.pointerOnNav = true; });
          this.megaBtn.addEventListener('mouseleave', () => { this.pointerOnNav = false; });
          this.addEventListener('mouseleave', () => this.closeMega());
          this.onDocClick = (e) => {
            if (!e.target.closest('.mega') && !e.target.closest('[data-mega-trigger]')) this.closeMega();
          };
          document.addEventListener('click', this.onDocClick);
        }

        this.burger?.addEventListener('click', () => this.openDrawer());
        this.scrim?.addEventListener('click', () => this.closeDrawer());
        this.drawer?.querySelector('[data-close-drawer]')?.addEventListener('click', () => this.closeDrawer());

        this.drawer?.addEventListener('click', (e) => {
          const row = e.target.closest('.mrow[data-sub]');
          if (row) {
            const sub = document.getElementById(row.dataset.sub);
            if (sub) {
              e.preventDefault();
              sub.classList.add('is-on');
              sub.setAttribute('aria-hidden', 'false');
              sub.inert = false;
              sub.querySelector('[data-sub-back]')?.focus();
            }
            return;
          }
          const back = e.target.closest('[data-sub-back]');
          if (back) {
            const sub = back.closest('.msub');
            sub.classList.remove('is-on');
            sub.setAttribute('aria-hidden', 'true');
            sub.inert = true;
          }
        });

        this.onKey = (e) => {
          if (e.key !== 'Escape') return;
          this.closeMega();
          if (this.drawer?.classList.contains('is-open')) { this.closeDrawer(); this.burger?.focus(); }
        };
        document.addEventListener('keydown', this.onKey);

        /* products under the search box as you type */
        this.querySelectorAll('form[role="search"]').forEach((form) => {
          const input = form.querySelector('input[name="q"]');
          const panel = form.querySelector('[data-suggest]');
          if (!input || !panel) return;
          const root = window.Shopify?.routes?.root || '/';
          const money = (value) => {
            const amount = Number(value);
            if (!isFinite(amount)) return '';
            const whole = Math.round(amount) === amount;
            const text = amount.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
            return (form.dataset.moneyFormat || '₱{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, text);
          };
          let timer;
          let last = '';

          const close = () => { panel.hidden = true; panel.innerHTML = ''; };

          const show = async (term) => {
            const url = `${root}search/suggest.json?q=${encodeURIComponent(term)}` +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
            let products = [];
            try {
              const res = await fetch(url);
              products = (await res.json()).resources?.results?.products || [];
            } catch (e) { return close(); }
            if (input.value.trim() !== term) return;
            if (!products.length) return close();
            panel.innerHTML = products.map((p) => {
              const img = p.featured_image?.url
                ? `<span class="sugg__ph"><img src="${p.featured_image.url}&width=120" alt="" loading="lazy"></span>`
                : '<span class="sugg__ph"></span>';
              return `<a href="${p.url}">${img}<span class="sugg__t">${p.title}</span><span class="sugg__p">${money(p.price)}</span></a>`;
            }).join('') + `<a class="sugg__all" href="${root}search?q=${encodeURIComponent(term)}">${form.dataset.allLabel || 'See all results'}</a>`;
            panel.hidden = false;
          };

          input.addEventListener('input', () => {
            const term = input.value.trim();
            clearTimeout(timer);
            if (!term) return close();
            if (term === last) return;
            last = term;
            timer = setTimeout(() => show(term), 160);
          });
          input.addEventListener('focus', () => { const term = input.value.trim(); if (term) show(term); });
          input.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
          document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
        });

        const msrchBtn = this.querySelector('[data-msrch-toggle]');
        const msrch = msrchBtn && document.getElementById(msrchBtn.getAttribute('aria-controls'));
        if (msrchBtn && msrch) {
          msrchBtn.addEventListener('click', () => {
            const open = msrch.classList.toggle('is-open');
            msrchBtn.setAttribute('aria-expanded', String(open));
            if (open) msrch.querySelector('input[type="search"]')?.focus();
          });
        }

        this.paintWishlist = () => {
          const badge = this.querySelector('[data-wishlist-count]');
          if (!badge) return;
          let n = 0;
          try { n = (JSON.parse(localStorage.getItem('blade.wishlist') || '[]') || []).length; } catch (err) {}
          badge.textContent = String(n);
          badge.hidden = n === 0;
        };
        document.addEventListener('blade:wishlist', this.paintWishlist);
        this.paintWishlist();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.scroller?.removeEventListener('scroll', this.onScroll);
        if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('blade:wishlist', this.paintWishlist);
        document.documentElement.removeAttribute('scroll-lock');
      }

      openMega() {
        this.megaPanel.classList.add('is-open');
        this.megaBtn.setAttribute('aria-expanded', 'true');
      }

      closeMega() {
        if (!this.megaPanel) return;
        this.megaPanel.classList.remove('is-open');
        this.megaBtn.setAttribute('aria-expanded', 'false');
      }

      openDrawer() {
        if (!this.drawer) return;
        this.closeMega();
        this.drawer.inert = false;
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.scrim.classList.add('is-open');
        this.burger.setAttribute('aria-expanded', 'true');
        document.documentElement.setAttribute('scroll-lock', '');
        this.drawer.querySelector('[data-close-drawer]')?.focus();
      }

      closeDrawer() {
        if (!this.drawer) return;
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.inert = true;
        this.scrim.classList.remove('is-open');
        this.burger?.setAttribute('aria-expanded', 'false');
        document.documentElement.removeAttribute('scroll-lock');
        this.drawer.querySelectorAll('.msub.is-on').forEach((sub) => {
          sub.classList.remove('is-on');
          sub.setAttribute('aria-hidden', 'true');
          sub.inert = true;
        });
      }
    }
    customElements.define('blade-header', BladeHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-hero')) {
    /* Swipeable scroll container that also advances on its own. Scroll position
       is the single source of truth, so a swipe and an automatic advance can
       never disagree about which slide is showing. */
    class BladeHero extends HTMLElement {
      static DELAY = 6000;

      connectedCallback() {
        this.track = this.querySelector('.hslides');
        this.dots = [...this.querySelectorAll('.hdot')];
        if (!this.track || this.dots.length < 2) return;

        this.onScroll = () => { clearTimeout(this.scrollT); this.scrollT = setTimeout(() => this.mark(this.current()), 90); };
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        this.onDot = (e) => {
          const dot = e.target.closest('.hdot');
          if (!dot) return;
          this.go(Number(dot.dataset.i));
          this.start();
        };
        this.stop = this.stop.bind(this);
        this.start = this.start.bind(this);

        this.track.addEventListener('scroll', this.onScroll);
        this.addEventListener('click', this.onDot);
        this.track.addEventListener('pointerdown', this.stop);
        this.track.addEventListener('pointerup', this.start);
        this.track.addEventListener('mouseenter', this.stop);
        this.track.addEventListener('mouseleave', this.start);
        document.addEventListener('visibilitychange', this.onVisibility);

        /* theme editor: show the slide being edited and hold it there */
        this.onBlockSelect = (e) => {
          const slide = e.target.closest?.('.hslide');
          if (!slide || !this.contains(slide)) return;
          this.stop();
          this.go(Number(slide.dataset.index));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.mark(this.current());
        if (!window.Shopify?.designMode) this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      current() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }

      mark(i) { this.dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }

      go(i) {
        const n = this.dots.length;
        const target = (i + n) % n;
        this.track.scrollTo({ left: this.track.clientWidth * target, behavior: 'smooth' });
        /* a programmatic scroll does not reliably emit a scroll event */
        this.mark(target);
      }

      start() {
        this.stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.go(this.current() + 1), BladeHero.DELAY);
      }

      stop() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
      }
    }
    customElements.define('blade-hero', BladeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-legal-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-faq')) {
    class BladeFaq extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const hd = e.target.closest('.pacc__hd');
          if (!hd) return;
          const open = hd.getAttribute('aria-expanded') === 'true';
          hd.setAttribute('aria-expanded', String(!open));
          document.getElementById(hd.getAttribute('aria-controls'))?.classList.toggle('is-open', !open);
        });
      }
    }
    customElements.define('blade-faq', BladeFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-main-collection"]) return;
  try {
    
  if (!customElements.get('blade-collection')) {
    class BladeCollection extends HTMLElement {
      connectedCallback() {
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onPop = () => this.load(location.href, false);
        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onChange);
        this.addEventListener('click', this.onClick);
        this.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
        window.addEventListener('popstate', this.onPop);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPop);
      }

      onChange(e) {
        const input = e.target;
        if (input.type === 'number') {
          if (e.type !== 'input') return;
          clearTimeout(this.priceT);
          this.priceT = setTimeout(() => this.apply(), 700);
          return;
        }
        if (e.type !== 'change') return;
        if (input.matches('input[type="checkbox"], select')) this.apply(input.id);
      }

      onClick(e) {
        const toggle = e.target.closest('[data-filter-toggle]');
        if (toggle) {
          const rail = this.querySelector('.filters');
          const open = rail.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
          return;
        }
        const more = e.target.closest('[data-more-toggle]');
        if (more) {
          more.parentElement.querySelectorAll('[data-more]').forEach((el) => { el.hidden = false; });
          more.remove();
          return;
        }
        const link = e.target.closest('a[data-facet-link]');
        if (link) {
          e.preventDefault();
          this.load(link.href, true, true);
        }
      }

      apply(focusId) {
        const form = this.querySelector('form[data-facets]');
        const params = new URLSearchParams();
        for (const [key, value] of new FormData(form)) {
          if (value !== '') params.append(key, value);
        }
        const url = `${form.action}${params.toString() ? `?${params}` : ''}`;
        this.load(url, true, false, focusId);
      }

      async load(url, push, scroll = false, focusId) {
        const rail = this.querySelector('.filters');
        const railOpen = rail?.classList.contains('is-open');
        const railOpenMore = [...this.querySelectorAll('.fgrp')].map((g) => !g.querySelector('[data-more-toggle]') && g.querySelector('[data-more]'));
        this.classList.add('is-loading');
        try {
          const fetchUrl = new URL(url, location.origin);
          fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
          const html = await (await fetch(fetchUrl)).text();
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('blade-collection');
          if (!next) throw new Error('No collection markup in response');
          this.innerHTML = next.innerHTML;
          if (railOpen) {
            this.querySelector('.filters')?.classList.add('is-open');
            this.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'true');
          }
          this.querySelectorAll('.fgrp').forEach((g, i) => {
            if (!railOpenMore[i]) return;
            g.querySelectorAll('[data-more]').forEach((el) => { el.hidden = false; });
            g.querySelector('[data-more-toggle]')?.remove();
          });
          if (push) history.pushState({}, '', url);
          if (focusId) document.getElementById(focusId)?.focus();
          if (scroll) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
          document.dispatchEvent(new CustomEvent('blade:wishlist'));
          document.dispatchEvent(new CustomEvent('blade:cards-rendered'));
        } catch (err) {
          window.location.href = url;
        } finally {
          this.classList.remove('is-loading');
        }
      }
    }
    customElements.define('blade-collection', BladeCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-main-product"]) return;
  try {
    
  if (!customElements.get('blade-fit-notice')) {
    /* "Fits your 2020 Toyota Vios" under the title. Products with no fitment data
       say so plainly instead of guessing. */
    class BladeFitNotice extends HTMLElement {
      connectedCallback() {
        this.paint = this.paint.bind(this);
        document.addEventListener('blade:vehicle', this.paint);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.paint);
        else this.paint();
      }

      disconnectedCallback() {
        document.removeEventListener('blade:vehicle', this.paint);
      }

      paint() {
        const bv = window.BladeVehicle;
        if (!bv) {
          document.addEventListener('blade:vehicle-ready', this.paint, { once: true });
          return;
        }
        const v = bv.read();
        const d = this.dataset;
        const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
        const yes = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M2 7.4 5.4 11 12 3.4"/></svg>';
        const no = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M3 3l8 8M11 3l-8 8"/></svg>';
        if (!v) {
          this.innerHTML = `<div class="vfit vfit--ask"><span>${esc(d.add)}</span><button type="button" data-veh-open>${esc(d.addLabel)}</button></div>`;
          return;
        }
        const result = bv.fits(d.fitment, d.universal === 'true', v);
        if (result === null) {
          this.innerHTML = `<div class="vfit vfit--ask"><span>${esc(d.ask)} <b>${esc(bv.label(v))}</b></span><button type="button" data-veh-open>${esc(d.change)}</button></div>`;
        } else {
          this.innerHTML = `<div class="vfit ${result ? 'vfit--yes' : 'vfit--no'}">${result ? yes : no}<span>${esc(result ? d.yes : d.no)} <b>${esc(bv.label(v))}</b></span><button type="button" data-veh-open>${esc(d.change)}</button></div>`;
        }
      }
    }
    customElements.define('blade-fit-notice', BladeFitNotice);
  }

  if (!customElements.get('blade-product')) {
    class BladeProduct extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.form = this.querySelector('form[data-product-form]');
        this.addEventListener('click', (e) => this.onClick(e));
        this.form?.addEventListener('submit', (e) => this.onSubmit(e));
        this.recordView();
        this.fillBoughtTogether();
        this.setupBuybar();
        this.addEventListener('blade:cart-added', (e) => {
          const b = e.target.closest('.fbt__add');
          if (!b) return;
          b.classList.add('is-added');
          setTimeout(() => b.classList.remove('is-added'), 1400);
        });
      }

      /* "Bought together" falls back to Shopify's own recommendations, so the
         list is always related to this product rather than a fixed set. */
      async fillBoughtTogether() {
        const box = this.querySelector('[data-fbt]');
        if (!box || box.querySelector('.fbt__i')) return;
        const root = window.Shopify?.routes?.root || '/';
        const limit = Number(box.dataset.limit) || 3;
        const fetchFor = async (intent) => {
          try {
            const res = await fetch(`${root}recommendations/products.json?product_id=${box.dataset.productId}&limit=${limit}&intent=${intent}`);
            if (!res.ok) return [];
            return (await res.json()).products || [];
          } catch (e) { return []; }
        };
        let picks = await fetchFor('complementary');
        if (!picks.length) picks = await fetchFor('related');
        picks = picks.filter((p) => p.available).slice(0, limit);
        if (!picks.length) return;

        const money = (cents) => this.money(cents);
        box.querySelector('.fbt__l').innerHTML = picks.map((p) => {
          const v = p.variants.find((x) => x.available) || p.variants[0];
          const one = p.variants.length === 1;
          const was = v.compare_at_price > v.price ? `<span class="fbt__was">${money(v.compare_at_price)}</span>` : '';
          const img = p.featured_image ? `<img src="${p.featured_image}&width=220" width="72" height="72" loading="lazy" decoding="async" alt="">` : '';
          const action = one
            ? `<button class="fbt__add" type="button" data-blade-add="${v.id}"><span class="fbt__plus" aria-hidden="true">+</span>${box.dataset.addLabel}</button>`
            : `<a class="fbt__add" href="${p.url}"><span class="fbt__plus" aria-hidden="true">+</span>${box.dataset.addLabel}</a>`;
          return `<li class="fbt__i"><span class="fbt__ph">${img}</span><span class="fbt__t">` +
            `<a class="fbt__n" href="${p.url}">${p.title}</a>` +
            `<span class="fbt__p">${money(v.price)}</span>${was}</span>${action}</li>`;
        }).join('');
        box.hidden = false;
      }

      recordView() {
        const KEY = 'blade.recent';
        const img = this.querySelector('.gal__main img');
        const item = {
          id: this.dataset.handle,
          href: this.dataset.url,
          name: this.querySelector('.buy h1')?.textContent.trim() || '',
          img: img?.currentSrc || img?.src || '',
          price: this.querySelector('[data-price]')?.textContent.trim() || '',
          was: this.querySelector('[data-compare]:not([hidden])')?.textContent.trim() || '',
        };
        try {
          const list = (JSON.parse(localStorage.getItem(KEY) || '[]') || []).filter((x) => x && x.id !== item.id);
          list.unshift(item);
          localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
        } catch (e) {}
      }

      /* mobile bar: shows once the page has scrolled past the buy box's button */
      setupBuybar() {
        const bar = this.querySelector('[data-buybar]');
        const add = this.querySelector('[data-add]');
        if (!bar || !add) return;
        /* fixed bars inside the page wrapper get clipped by its scroll container,
           so the bar moves to <body>, inside its own .blade host for the tokens */
        const host = document.createElement('div');
        host.className = 'blade blade-buybar-host';
        host.appendChild(bar);
        document.body.appendChild(host);
        this.buybarHost = host;
        this.buybar = bar;
        bar.querySelector('[data-bar-add]').addEventListener('click', () => {
          if (add.disabled) return;
          this.form.requestSubmit ? this.form.requestSubmit(add) : add.click();
        });
        const io = new IntersectionObserver(([entry]) => {
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', past);
          bar.setAttribute('aria-hidden', String(!past));
          bar.querySelector('[data-bar-add]').tabIndex = past ? 0 : -1;
        });
        io.observe(add);
      }

      disconnectedCallback() {
        this.buybarHost?.remove();
      }

      money(cents) {
        const format = this.dataset.moneyFormat || '₱{{amount}}';
        const value = cents / 100;
        const whole = Math.round(value) === value;
        const amount = value.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          if (key === 'amount_with_comma_separator') return amount.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
          if (key === 'amount_no_decimals') return Math.round(value).toLocaleString('en-US');
          return amount;
        });
      }

      onClick(e) {
        const thumb = e.target.closest('.gal__t');
        if (thumb) return this.showMedia(thumb.dataset.mediaId);

        const chip = e.target.closest('.chip');
        if (chip) {
          const opt = chip.closest('.opt');
          opt.querySelectorAll('.chip').forEach((c) => { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', String(c === chip)); });
          return this.update();
        }

        const qty = this.querySelector('[data-qty]');
        if (e.target.closest('.q-up')) this.setQty(Number(qty.textContent) + 1);
        if (e.target.closest('.q-dn')) this.setQty(Math.max(1, Number(qty.textContent) - 1));

        const hd = e.target.closest('.pacc__hd');
        if (hd) {
          const open = hd.getAttribute('aria-expanded') === 'true';
          hd.setAttribute('aria-expanded', String(!open));
          document.getElementById(hd.getAttribute('aria-controls'))?.classList.toggle('is-open', !open);
        }
      }

      setQty(n) {
        this.querySelector('[data-qty]').textContent = String(n);
        this.querySelector('[data-qty-input]').value = String(n);
      }

      selected() {
        return [...this.querySelectorAll('.opt')].map((o) => o.querySelector('.chip.is-on')?.dataset.value);
      }

      find(options) {
        return this.variants.find((v) => v.options.every((o, i) => o === options[i]));
      }

      update() {
        const sel = this.selected();
        const variant = this.find(sel);

        this.querySelectorAll('.opt').forEach((opt, i) => {
          opt.querySelector('[data-option-label]').textContent = sel[i] || '';
          opt.querySelectorAll('.chip').forEach((chip) => {
            const trial = [...sel];
            trial[i] = chip.dataset.value;
            const match = this.find(trial);
            const off = !match || !match.available;
            chip.classList.toggle('is-off', off);
            const note = chip.querySelector('[data-chip-note]');
            note.textContent = off ? this.soldOutLabel() : (variant && match.price !== variant.price ? this.money(match.price) : '');
          });
        });

        const add = this.querySelector('[data-add]');
        const express = this.querySelector('[data-express]');
        if (express) express.hidden = !variant || !variant.available;
        if (!variant) {
          add.disabled = true;
          add.textContent = this.unavailableLabel();
          return;
        }

        this.querySelector('[data-variant-id]').value = variant.id;
        this.querySelector('[data-price]').textContent = this.money(variant.price);
        const compare = this.querySelector('[data-compare]');
        const save = this.querySelector('[data-save]');
        const onSale = variant.compare_at_price > variant.price;
        compare.hidden = !onSale;
        save.hidden = !onSale;
        if (onSale) {
          const pct = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          compare.textContent = this.money(variant.compare_at_price);
          save.textContent = save.textContent.replace(/\d+/, pct);
        }
        const free = this.querySelector('[data-free-note]');
        if (free) free.hidden = variant.price < Number(this.dataset.freeThreshold || 0);
        add.disabled = !variant.available;
        add.textContent = variant.available ? this.addLabel(variant.price) : this.soldOutLabel();
        if (this.buybar) {
          this.buybar.querySelector('[data-bar-price]').textContent = this.money(variant.price);
          const barAdd = this.buybar.querySelector('[data-bar-add]');
          barAdd.disabled = !variant.available;
          if (!variant.available) barAdd.textContent = this.soldOutLabel();
          else if (barAdd.dataset.label) barAdd.textContent = barAdd.dataset.label;
          const note = this.buybar.querySelector('[data-bar-note]');
          note.textContent = `${variant.title} · ${variant.available ? this.dataset.inStockLabel : this.soldOutLabel()}`;
        }
        if (variant.featured_media) this.showMedia(variant.featured_media.id);

        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      addLabel(price) {
        return this.dataset.addLabel.replace('__PRICE__', this.money(price));
      }

      soldOutLabel() { return this.dataset.soldOutLabel; }
      unavailableLabel() { return this.dataset.unavailableLabel; }

      showMedia(id) {
        const thumb = this.querySelector(`.gal__t[data-media-id="${id}"]`);
        const img = this.querySelector('.gal__main .ph__img');
        if (!thumb || !img) return;
        this.querySelectorAll('.gal__t').forEach((t) => t.classList.toggle('is-on', t === thumb));
        img.srcset = thumb.dataset.srcset;
        img.src = thumb.dataset.src;
      }

      async onSubmit(e) {
        e.preventDefault();
        const add = this.querySelector('[data-add]');
        const error = this.querySelector('[data-error]');
        if (add.disabled || !window.bladeCartAdd) return this.form.submit();
        add.disabled = true;
        error.hidden = true;
        try {
          await window.bladeCartAdd(this.querySelector('[data-variant-id]').value, Number(this.querySelector('[data-qty-input]').value));
        } catch (err) {
          error.textContent = err.message;
          error.hidden = false;
        } finally {
          add.disabled = false;
        }
      }
    }
    customElements.define('blade-product', BladeProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-quick-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-quick-bar')) {
    /* mirrors what is already saved: the vehicle and the wishlist */
    class BladeQuickBar extends HTMLElement {
      connectedCallback() {
        this.paint = this.paint.bind(this);
        document.addEventListener('blade:vehicle', this.paint);
        document.addEventListener('blade:wishlist', this.paint);
        window.addEventListener('storage', this.paint);
        this.paint();
      }
      disconnectedCallback() {
        document.removeEventListener('blade:vehicle', this.paint);
        document.removeEventListener('blade:wishlist', this.paint);
        window.removeEventListener('storage', this.paint);
      }
      paint() {
        const veh = this.querySelector('[data-qbar-veh]');
        if (veh) {
          let v = null;
          try { v = JSON.parse(localStorage.getItem('blade.vehicle') || 'null'); } catch (e) {}
          veh.textContent = v ? [v.year, v.make, v.model].join(' ') : veh.dataset.empty;
          const ok = this.querySelector('[data-qbar-ok]');
          if (ok) ok.hidden = !v;
        }
        const wl = this.querySelector('[data-qbar-wl]');
        if (wl) {
          let n = 0;
          try { n = (JSON.parse(localStorage.getItem('blade.wishlist') || '[]') || []).length; } catch (e) {}
          wl.textContent = String(n);
          wl.hidden = n === 0;
        }
      }
    }
    customElements.define('blade-quick-bar', BladeQuickBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-related-products"]) return;
  try {
    
  if (!customElements.get('blade-related')) {
    class BladeRelated extends HTMLElement {
      connectedCallback() {
        if (this.childElementCount) return;
        const io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 400px 0px' });
        this.hidden = false;
        this.style.minHeight = '1px';
        io.observe(this);
      }

      async load() {
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('blade-related');
          if (next && next.childElementCount) {
            this.innerHTML = next.innerHTML;
            this.querySelectorAll('.rv').forEach((el) => el.classList.add('in'));
            document.dispatchEvent(new CustomEvent('blade:wishlist'));
            document.dispatchEvent(new CustomEvent('blade:cards-rendered'));
          } else {
            this.hidden = true;
          }
        } catch (err) {
          this.hidden = true;
        }
      }
    }
    customElements.define('blade-related', BladeRelated);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-sale-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-sale-hero')) {
    const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    /* Month, day and seconds since midnight in Asia/Manila, whatever the
       visitor's own clock zone is. The Philippines is UTC+8 with no DST. */
    const manila = () => {
      const d = new Date(Date.now() + 8 * 3600 * 1000);
      return { month: d.getUTCMonth() + 1, day: d.getUTCDate(), year: d.getUTCFullYear(), secs: d.getUTCHours() * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds() };
    };

    class BladeSaleHero extends HTMLElement {
      connectedCallback() {
        this.units = [...this.querySelectorAll('[data-cd]')];
        this.unitLabels = [...this.querySelectorAll('[data-cd-unit]')];
        this.render();
        this.timer = setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() { clearInterval(this.timer); }

      render() {
        const now = manila();
        const double = now.month === now.day;
        if (double !== this.lastDouble) this.label(now, double);
        this.lastDouble = double;
        this.tick(now, double);
      }

      label(now, double) {
        const d = this.dataset;
        const sale = double ? `${now.month}.${now.month}` : d.word;
        const ribbon = double ? `${MONTHS[now.month - 1].toUpperCase()} ${now.day} ${d.suffix}`.trim() : d.ribbon;
        const badge = this.querySelector('.s99b');
        badge.classList.toggle('s99b--word', !double);
        badge.dataset.len = String(sale.length);
        badge.setAttribute('aria-label', d.alt.replace('[sale]', sale).replace('[ribbon]', ribbon));
        this.querySelector('[data-sale]').textContent = sale;
        this.querySelector('[data-ribbon]').textContent = ribbon;
        this.querySelector('.s99b__rib').hidden = !ribbon;
        const button = this.querySelector('[data-button]');
        if (button) button.textContent = d.button.replace('[sale]', sale);

        const next = this.nextDouble(now);
        this.querySelector('[data-cd-label]').textContent = double ? d.liveLabel : d.nextLabel.replace('[next]', `${next}.${next}`);
        this.querySelector('.s99cd').hidden = !double && d.regular === 'hide';
        const names = double ? ['hrs', 'mins', 'secs'] : ['days', 'hrs', 'mins'];
        this.unitLabels.forEach((el, i) => { el.textContent = d[names[i]]; });
      }

      /* the next month whose double date is still ahead */
      nextDouble(now) { return now.day < now.month ? now.month : (now.month % 12) + 1; }

      tick(now, double) {
        const pad = (n) => String(n).padStart(2, '0');
        let values;
        if (double) {
          const left = 86400 - now.secs;
          values = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60];
        } else {
          const m = this.nextDouble(now);
          const year = m < now.month ? now.year + 1 : now.year;
          const target = Date.UTC(year, m - 1, m) / 1000;
          const today = Date.UTC(now.year, now.month - 1, now.day) / 1000 + now.secs;
          const left = Math.max(0, Math.floor(target - today));
          values = [Math.floor(left / 86400), Math.floor(left / 3600) % 24, Math.floor(left / 60) % 60];
        }
        this.units.forEach((el, i) => { el.textContent = pad(values[i]); });
      }
    }
    customElements.define('blade-sale-hero', BladeSaleHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-saved-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-saved')) {
    const KEYS = { recent: 'blade.recent', wishlist: 'blade.wishlist' };
    const read = (key) => { try { return JSON.parse(localStorage.getItem(key) || '[]') || []; } catch (e) { return []; } };
    const write = (key, list) => { try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {} };
    const cardCache = new Map();

    const fetchCard = (handle) => {
      if (!cardCache.has(handle)) {
        const root = window.Shopify?.routes?.root || '/';
        cardCache.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=blade-card`)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => (html.includes('b-card') ? html : ''))
          .catch(() => ''));
      }
      return cardCache.get(handle);
    };

    class BladeSaved extends HTMLElement {
      connectedCallback() {
        this.key = KEYS[this.dataset.mode];
        this.render = this.render.bind(this);
        this.addEventListener('click', (e) => {
          if (!e.target.closest('[data-clear]')) return;
          write(this.key, []);
          if (this.dataset.mode === 'wishlist') document.dispatchEvent(new CustomEvent('blade:wishlist'));
          this.render();
        });
        if (this.dataset.mode === 'wishlist') document.addEventListener('blade:wishlist', this.render);
        window.addEventListener('storage', this.render);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('blade:wishlist', this.render);
        window.removeEventListener('storage', this.render);
      }

      async render() {
        const token = (this.token = Symbol('render'));
        const items = read(this.key)
          .filter((x) => x && x.id && x.id !== this.dataset.current)
          .slice(0, Number(this.dataset.limit));

        const count = this.querySelector('[data-count]');
        if (count) count.textContent = items.length === 1 ? this.dataset.one : this.dataset.other.replace('__N__', items.length);
        const empty = this.querySelector('[data-empty]');
        const grid = this.querySelector('[data-grid]');

        if (!items.length) {
          grid.innerHTML = '';
          if (empty) empty.hidden = false;
          if (this.dataset.mode === 'recent') this.hidden = true;
          return;
        }

        const cards = await Promise.all(items.map((x) => fetchCard(x.id)));
        if (token !== this.token) return;
        grid.innerHTML = cards.filter(Boolean).join('');
        const shown = grid.children.length;
        if (empty) empty.hidden = shown > 0;
        if (this.dataset.mode === 'recent') this.hidden = shown === 0;
        document.dispatchEvent(new CustomEvent('blade:cards-rendered'));
      }
    }
    customElements.define('blade-saved', BladeSaved);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-split')) {
    /* Steps through the list every 5s, swapping the photo to match. */
    class BladeSplit extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-rotate')) return;
        this.rows = [...this.querySelectorAll('.bundlerot__list li')];
        this.shots = [...this.querySelectorAll('.bundlerot__media .ph__img')];
        if (this.rows.length < 2) return;
        this.i = 0;
        this.rows.forEach((row, n) => row.addEventListener('click', () => { this.show(n); this.start(); }));
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.show(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      show(n) {
        this.i = (n + this.rows.length) % this.rows.length;
        this.rows.forEach((r, k) => r.classList.toggle('is-on', k === this.i));
        this.shots.forEach((s, k) => s.classList.toggle('is-on', k === this.i));
      }

      start() { this.stop(); this.timer = setInterval(() => this.show(this.i + 1), 5000); }

      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    }
    customElements.define('blade-split', BladeSplit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-sticky-bar')) {
    class BladeStickyBar extends HTMLElement {
      connectedCallback() {
        this.onScroll = () => {
          const y = Math.max(window.scrollY, document.querySelector('.page-wrapper')?.scrollTop || 0);
          const on = y > Number(this.dataset.offset || 560);
          if (on === this.classList.contains('is-on')) return;
          this.classList.toggle('is-on', on);
          this.setAttribute('aria-hidden', String(!on));
          this.querySelectorAll('a').forEach((a) => { a.tabIndex = on ? 0 : -1; });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.querySelector('.page-wrapper')?.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.querySelector('.page-wrapper')?.removeEventListener('scroll', this.onScroll);
      }
    }
    customElements.define('blade-sticky-bar', BladeStickyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-store-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blade-store-filter')) {
    /* One control for every branch list on the page: the buttons show a whole
       region, the search box narrows to matching branches and hides the city
       headings and regions left with nothing. */
    class BladeStoreFilter extends HTMLElement {
      connectedCallback() {
        this.groups = [...document.querySelectorAll('.sgroup')];
        if (!this.groups.length) return;
        this.row = this.querySelector('.regions');
        this.empty = this.querySelector('.regions__empty');
        this.build();
        this.row.addEventListener('click', (e) => {
          const btn = e.target.closest('.rbtn');
          if (!btn) return;
          const search = this.querySelector('#BladeStoreSearch');
          if (search) search.value = '';
          this.showRegion(btn.dataset.region);
          this.mark(btn);
        });
        this.querySelector('#BladeStoreSearch')?.addEventListener('input', (e) => this.search(e.target.value.trim().toLowerCase()));
      }

      build() {
        const all = this.querySelector('[data-region="all"]');
        all.querySelector('[data-count]').textContent = document.querySelectorAll('.store').length;
        this.groups.forEach((g) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rbtn';
          btn.dataset.region = g.dataset.region;
          btn.innerHTML = `${g.dataset.regionLabel || g.dataset.region} <em>${g.querySelectorAll('.store').length}</em>`;
          this.row.appendChild(btn);
        });
      }

      mark(btn) {
        [...this.row.querySelectorAll('.rbtn')].forEach((b) => b.classList.toggle('is-on', b === btn));
      }

      showRegion(region) {
        this.empty.hidden = true;
        this.groups.forEach((g) => {
          g.hidden = region !== 'all' && g.dataset.region !== region;
          g.querySelectorAll('.scity, .store').forEach((el) => { el.hidden = false; });
        });
      }

      search(value) {
        if (!value) {
          this.showRegion('all');
          this.mark(this.row.querySelector('[data-region="all"]'));
          return;
        }
        let hits = 0;
        this.groups.forEach((group) => {
          let groupHit = false;
          group.querySelectorAll('.scity').forEach((city) => {
            let cityHit = false;
            city.querySelectorAll('.store').forEach((store) => {
              const hit = store.textContent.toLowerCase().includes(value);
              store.hidden = !hit;
              if (hit) { cityHit = true; hits += 1; }
            });
            city.hidden = !cityHit;
            if (cityHit) groupHit = true;
          });
          group.hidden = !groupHit;
        });
        this.empty.hidden = hits > 0;
        this.mark(null);
      }
    }
    customElements.define('blade-store-filter', BladeStoreFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-store-list"] && !Shopify.designMode) return;
  try {
    
  /* "Directions" opens the branch on a map in a dialog instead of leaving the
     page; the link still works when the dialog or JS is unavailable. */
  if (!window.__bladeStoreMap) {
    window.__bladeStoreMap = true;

    const build = () => {
      const dialog = document.createElement('dialog');
      dialog.className = 'smap blade';
      dialog.innerHTML =
        '<div class="smap__top"><p class="smap__t" data-map-title></p>' +
        '<button class="smap__x" type="button" aria-label="Close">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" aria-hidden="true"><path d="M5.5 5.5l13 13M18.5 5.5l-13 13"/></svg>' +
        '</button></div><iframe title="Map" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>' +
        '<div class="smap__foot"><a target="_blank" rel="noopener" data-map-out>Open in Google Maps</a></div>';
      document.body.appendChild(dialog);
      dialog.querySelector('.smap__x').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { dialog.querySelector('iframe').src = 'about:blank'; });
      return dialog;
    };

    let dialog;
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[data-map]');
      if (!link || !window.HTMLDialogElement) return;
      e.preventDefault();
      dialog = dialog || build();
      const query = encodeURIComponent(link.dataset.map);
      dialog.querySelector('[data-map-title]').textContent = link.dataset.mapTitle || '';
      dialog.querySelector('iframe').src = `https://www.google.com/maps?q=${query}&output=embed`;
      dialog.querySelector('[data-map-out]').href = link.href;
      dialog.showModal();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade-vehicle-band"]) return;
  try {
    
  if (!customElements.get('blade-vehicle-band')) {
    class BladeVehicleBand extends HTMLElement {
      connectedCallback() {
        this.paint = this.paint.bind(this);
        document.addEventListener('blade:vehicle', this.paint);
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-band-clear]')) window.BladeVehicle?.write(null);
        });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.paint);
        else this.paint();
      }

      disconnectedCallback() {
        document.removeEventListener('blade:vehicle', this.paint);
      }

      paint() {
        const bv = window.BladeVehicle;
        let v = null;
        try { v = JSON.parse(localStorage.getItem('blade.vehicle') || 'null'); } catch (e) {}
        const d = this.dataset;
        const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        const arrow = '<svg width="13" height="9" viewBox="0 0 18 12" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M1 6h15M11.5 1 17 6l-5.5 5"/></svg>';
        this.hidden = false;
        this.querySelector('[data-band-ok]').hidden = !v;
        const text = this.querySelector('[data-band-text]');
        const acts = this.querySelector('[data-band-acts]');
        if (v) {
          const name = bv ? bv.label(v) : [v.year, v.make, v.model].join(' ');
          text.innerHTML = `<b>${esc(name)}</b><small>${esc(d.setText)}</small>`;
          acts.innerHTML = `<button class="vband__a" type="button" data-veh-open>${esc(d.change)}</button><button class="vband__a" type="button" data-band-clear>${esc(d.clear)}</button>`;
        } else {
          text.innerHTML = `<b>${esc(d.addTitle)}</b><small>${esc(d.addText)}</small>`;
          acts.innerHTML = `<button class="vband__go" type="button" data-veh-open>${esc(d.add)} ${arrow}</button>`;
        }
      }
    }
    customElements.define('blade-vehicle-band', BladeVehicleBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade2-clips"] && !Shopify.designMode) return;
  try {
    
  if (!window.__blade2Clips) {
    window.__blade2Clips = true;

    const play = (video) => {
      if (!video.src) video.src = video.dataset.b2Clip;
      video.play().then(() => video.classList.add('is-playing')).catch(() => {});
    };

    const arm = () => {
      const clips = [...document.querySelectorAll('.b2clip__vid[data-b2-clip]')];
      if (!clips.length) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      const watcher = new IntersectionObserver(
        (entries) => entries.forEach((e) => (e.isIntersecting ? play(e.target) : e.target.pause())),
        { threshold: 0.25 }
      );
      clips.forEach((clip) => watcher.observe(clip));
    };

    /* sound on for one clip at a time, and never by surprise */
    const toggleSound = (button) => {
      const card = button.closest('.b2clip');
      const video = card && card.querySelector('.b2clip__vid');
      if (!video) return;
      const turningOn = video.muted;
      document.querySelectorAll('.b2clip__vid').forEach((v) => { v.muted = true; });
      document.querySelectorAll('.b2clip__sound').forEach((b) => {
        b.setAttribute('aria-label', b.dataset.on || '');
        b.querySelector('use').setAttribute('href', '#b2-mute');
      });
      if (turningOn) {
        video.muted = false;
        play(video);
        button.setAttribute('aria-label', button.dataset.off || '');
        button.querySelector('use').setAttribute('href', '#b2-unmute');
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.b2clip__sound');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      toggleSound(button);
    });
    document.addEventListener('keydown', (event) => {
      const button = event.target.closest('.b2clip__sound');
      if (!button || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      toggleSound(button);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
    document.addEventListener('shopify:section:load', arm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade2-deals"] && !Shopify.designMode) return;
  try {
    
  if (!window.__blade2Deals) {
    window.__blade2Deals = true;
    document.addEventListener('click', (event) => {
      const tab = event.target.closest('.b2tabs button[data-b2-tab]');
      if (!tab) return;
      const section = tab.closest('.blade2');
      section.querySelectorAll('.b2tabs button[data-b2-tab]').forEach((b) => {
        const on = b === tab;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      section.querySelectorAll('[data-b2-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.b2Panel !== tab.dataset.b2Tab;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade2-footer"] && !Shopify.designMode) return;
  try {
    
  if (!window.__blade2Footer) {
    window.__blade2Footer = true;
    document.addEventListener('click', (event) => {
      const head = event.target.closest('.b2fcol__hd[aria-controls]');
      if (!head) return;
      /* folding is a phone affordance; the columns are always open above that */
      if (!matchMedia('(max-width: 760px)').matches) return;
      head.setAttribute('aria-expanded', head.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade2-hero"] && !Shopify.designMode) return;
  try {
    
  /* The slides cross-fade on a timer and on a dot press. Paused when the tab
     is hidden and when the visitor prefers less motion. */
  if (!window.__blade2Hero) {
    window.__blade2Hero = true;
    const start = (root) => {
      const slides = [...root.querySelectorAll('[data-b2-slides] img')];
      const dots = [...root.querySelectorAll('[data-b2-dots] button')];
      if (slides.length < 2) return;
      let at = 0;
      let timer = null;
      /* a held-back slide gets its source the moment it is wanted */
      const wake = (img) => {
        if (!img || !img.dataset.b2Src) return;
        img.srcset = img.dataset.b2Srcset || '';
        img.src = img.dataset.b2Src;
        delete img.dataset.b2Src;
        delete img.dataset.b2Srcset;
      };
      const show = (next) => {
        wake(slides[(next + slides.length) % slides.length]);
        slides[at].classList.remove('is-on');
        if (dots[at]) dots[at].classList.remove('is-on');
        at = (next + slides.length) % slides.length;
        slides[at].classList.add('is-on');
        if (dots[at]) dots[at].classList.add('is-on');
      };
      const play = () => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stop();
        timer = setInterval(() => show(at + 1), 6000);
      };
      const stop = () => { if (timer) clearInterval(timer); timer = null; };
      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); play(); }));
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
      /* once the page is quiet, fetch the next one so the first turn is smooth */
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 2500));
      idle(() => wake(slides[1]));
      play();
    };
    const boot = () => document.querySelectorAll('.b2hero').forEach(start);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade2-main-product"]) return;
  try {
    
  /* Gallery, quantity and variant choice. The variant select is the source of
     truth, so the theme's own form posts whatever is picked here. */
  if (!window.__blade2Pdp) {
    window.__blade2Pdp = true;

    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-b2-src]');
      if (thumb) {
        const main = document.getElementById('b2GalMain');
        if (main) {
          main.src = thumb.getAttribute('data-b2-src');
          main.removeAttribute('srcset');
        }
        thumb.parentElement.querySelectorAll('button').forEach((b) => b.classList.remove('is-on'));
        thumb.classList.add('is-on');
        return;
      }

      const step = event.target.closest('[data-b2-step]');
      if (step) {
        const input = step.parentElement.querySelector('input');
        const next = Math.max(1, (Number(input.value) || 1) + Number(step.getAttribute('data-b2-step')));
        input.value = next;
        return;
      }

      const option = event.target.closest('[data-b2-option]');
      if (option) {
        const form = option.closest('form');
        const select = form.querySelector('[data-b2-variants]');
        option.parentElement.querySelectorAll('button').forEach((b) => b.classList.remove('is-on'));
        option.classList.add('is-on');

        const picked = [...form.querySelectorAll('.b2opts')].map((row) => {
          const on = row.querySelector('button.is-on');
          return on ? on.getAttribute('data-b2-value') : null;
        });
        const want = picked.filter(Boolean).join(' / ');
        const match = [...select.options].find((o) => o.getAttribute('data-b2-title') === want);
        if (match) {
          select.value = match.value;
          const total = form.querySelector('[data-b2-total]');
          if (total) total.textContent = match.getAttribute('data-b2-price');
          const url = new URL(window.location);
          url.searchParams.set('variant', match.value);
          window.history.replaceState({}, '', url);
        }
        const chosen = form.querySelector(`[data-b2-chosen="${option.getAttribute('data-b2-option')}"]`);
        if (chosen) chosen.textContent = option.getAttribute('data-b2-value');
      }

      const wish = event.target.closest('.b2wish');
      if (wish) {
        const on = wish.getAttribute('aria-pressed') === 'true';
        wish.setAttribute('aria-pressed', String(!on));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blade2-news"] && !Shopify.designMode) return;
  try {
    
  if (!window.__blade2Prefs) {
    window.__blade2Prefs = true;
    document.addEventListener('click', (event) => {
      const chip = event.target.closest('.b2prefs button[data-b2-pref]');
      if (!chip) return;
      chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');

      const form = chip.closest('form');
      const tags = form && form.querySelector('[data-b2-tags]');
      if (!tags) return;
      /* the chosen interests travel with the signup as customer tags */
      const picked = [...form.querySelectorAll('[data-b2-pref][aria-pressed="true"]')]
        .map((b) => b.dataset.b2Pref);
      tags.value = ['newsletter'].concat(picked).join(',');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
